import { z } from "zod";

export enum AppMode {
  FIREBASE = "FIREBASE",
  MOCK = "MOCK",
  CONFIG_ERROR = "CONFIG_ERROR",
}

export const appModeSchema = z.nativeEnum(AppMode);

export enum Role {
  CUCS = "CUCS",
  VSM = "VSM",
  AIR_VEHICLE = "AIR_VEHICLE",
  PAYLOAD = "PAYLOAD",
  C4I = "C4I",
  SIMULATOR = "SIMULATOR",
  ANALYZER = "ANALYZER",
  ANY = "ANY",
}

export const roleSchema = z.nativeEnum(Role);

export enum TransferMode {
  PUSH = "PUSH",
  PULL = "PULL",
  PUSH_PULL = "PUSH_PULL",
  COMMAND = "COMMAND",
  RESPONSE = "RESPONSE",
  EVENT = "EVENT",
}

export const transferModeSchema = z.nativeEnum(TransferMode);

export enum DataType {
  UINT8 = "uint8",
  INT8 = "int8",
  UINT16 = "uint16",
  INT16 = "int16",
  UINT32 = "uint32",
  INT32 = "int32",
  FLOAT32 = "float32",
  FLOAT64 = "float64",
  STRING = "string",
  BYTES = "bytes",
  BOOLEAN = "boolean",
  ENUM = "enum",
}

export const dataTypeSchema = z.nativeEnum(DataType);

export enum Endian {
  BIG = "BIG",
  LITTLE = "LITTLE",
  NETWORK = "NETWORK",
}

export const endianSchema = z.nativeEnum(Endian);

export enum ValidationSeverity {
  PASS = "PASS",
  WARN = "WARN",
  FAIL = "FAIL",
  INFO = "INFO",
  UNKNOWN = "UNKNOWN",
  UNSUPPORTED = "UNSUPPORTED",
}

export const validationSeveritySchema = z.nativeEnum(ValidationSeverity);

export enum Direction {
  TX = "TX",
  RX = "RX",
  INTERNAL = "INTERNAL",
}

export const directionSchema = z.nativeEnum(Direction);

export enum SourcePocReference {
  PUBLIC_POC_REFERENCE = "PUBLIC_POC_REFERENCE",
}

export const sourcePocReferenceSchema = z.nativeEnum(SourcePocReference);

export enum VerificationStatus {
  REQUIRES_MND_STD_VERIFICATION = "REQUIRES_MND_STD_VERIFICATION",
  VERIFIED = "VERIFIED",
  DRAFT = "DRAFT",
}

export const verificationStatusSchema = z.nativeEnum(VerificationStatus);

export type Timestamp = string;

export const timestampSchema = z.string().datetime({ offset: true });

export interface Coordinates {
  latitude: number;
  longitude: number;
  altitudeM: number;
}

export const coordinatesSchema = z.object({
  latitude: z.number(),
  longitude: z.number(),
  altitudeM: z.number(),
});

export interface Vector3d {
  x: number;
  y: number;
  z: number;
}

export const vector3dSchema = z.object({
  x: z.number(),
  y: z.number(),
  z: z.number(),
});
